module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BlackIt.f7e1a502.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BlackIt.ttf
// module id = 358
// module chunks = 3